import React from 'react';
import { Dropdown } from "primereact/dropdown";
import "./dropdown.scss";

export const DropdownTemplate = (props) => {

    const optionTemplate = (option) => {
        return (
            <div className="d-flex">
                <i className={`${option?.icon}`} style={{ color: option?.color }} />
                <span className={`${option?.icon && 'ml-3'}`}>{option ? option[props.optionLabel] : props.placeholder}</span>
            </div>
        );
    }

    const selectedOption = (option) => {
        return (
            <div className="d-flex">
                <i className={`${option?.icon}`} style={{ color: option?.color }} />
                <span className={`${option?.icon && 'ml-3'}`}>{option ? option[props.optionLabel] : props.placeholder}</span>
            </div>
        );
    }

    return (
        <div className={`p-inputgroup ${props.rootClassName}`} style={{ width: props.width, height: props.height }} >
            {
                props.icon &&
                <span className="p-inputgroup-addon">
                    <i className={props.icon}></i>
                </span>
            }
            <Dropdown
                value={props.selectedItem}
                options={props.options}
                onChange={props.onItemChange}
                optionLabel={props.optionLabel}
                valueTemplate={selectedOption}
                placeholder={props.placeholder}
                itemTemplate={optionTemplate}
                className={props.className}
                scrollHeight={props.scrollHeight ? props.scrollHeight : "500"}
                onMouseDown={props.onMouseDown}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                style={props.style}
                optionValue={props.optionValue}
                inputStyle={{ padding: "0.4rem" }}
            />
        </div>
    );
}